
export const KarmaPoolCycleManager = (local, setLocal, getURLBasePath) => {
    function refresh() {
        fetch(getURLBasePath() + 'cycle')
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
            // replace cycle on local as object
            setLocal(prevValue => {
                return { ...prevValue, cycle: data };
            });

            localStorage.setItem("local.cycle", JSON.stringify(data));
        })
        .catch((err) => {
            console.log(err.message);
        });
    }

    return {
        refresh: refresh
    };
}